import { render, staticRenderFns } from "./PostSummary.vue?vue&type=template&id=73f6d957&scoped=true&"
import script from "./PostSummary.vue?vue&type=script&lang=js&"
export * from "./PostSummary.vue?vue&type=script&lang=js&"
import style0 from "./PostSummary.vue?vue&type=style&index=0&id=73f6d957&scoped=true&lang=css&"
import style1 from "./PostSummary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f6d957",
  null
  
)

export default component.exports